// utils/printReport.js
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const handlePrint = (filteredAlertes) => {
    try {
      const printWindow = window.open("Gescopifor", "_blank");
      printWindow.document.write(`
        <html lang="fr">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Rapport des Alertes</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 60px;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
            }
            .header p {
              margin: 0;
            }
            h1 {
              margin-bottom: 10px;
            }
            h2 {
              text-align: left;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            th, td {
              border: 1px solid #000;
              padding: 8px;
            }
            th {
              background-color: #f2f2f2;
            }
            .footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              text-align: center;
              margin-top: 20px;
            }
            .footer p {
              margin: 0;
            }
            .footer div {
              display: flex;
              flex-direction: column;
              text-align: left;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Liste des alertes</h1>
          </div>
          <h2>Tableau des Consommations</h2>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nom Client</th>
                <th>Numéro Référence Client</th>
              </tr>
            </thead>
            <tbody>
              ${filteredAlertes
                .map(
                  (alerte) => `
                  <tr>
                    <td>${alerte.id}</td>
                    <td>${alerte.clientName}</td>
                    <td>${alerte.waterBillRefNumber}</td>
                  </tr>
                `
                )
                .join("")}
            </tbody>
          </table>
          <div class="footer">
            <div>
              <p>ASUFOR DAROU NGARAF</p>
              <p>Commune de Bandègne Ouolof, Louga (Louga)</p>
              <p>Téléphone : (+221) 77 123 45 67</p>
            </div>
            <p>Darou Ngaraf, le ${new Date().toLocaleDateString()}</p>
          </div>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    } catch (error) {
      console.error("Erreur lors de l'impression des données :", error);
      toast.error(
        "Erreur lors de l'impression des données. Veuillez réessayer."
      );
    }
  };
  